<template>
    <div>

        <rkm-row v-for="(examesSolicitados, index) in data.form.examesSolicitados" :key="index">
            <rkm-col>

                <rkm-area
                    title="Solicitados"
                    type="fieldset"
                    no-margin-top
                >
                    <rkm-row>
                        <rkm-col
                            v-for="(exameAvaliado, index) in examesSolicitados['exames']"
                            :key="index"
                            class="mb-2"
                            cols="6"
                        >
                            <rkm-list-group>
                                <rkm-list-group-item class="rkm-list-group-item">
                                    <rkm-row>
                                        <rkm-col
                                            class="align-self-center"
                                            cols="12"
                                        >
                                            <rkm-form-checkbox
                                                checked
                                                disabled
                                            >
                                                {{exameAvaliado.descricao}}
                                            </rkm-form-checkbox>
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-list-group-item>
                            </rkm-list-group>
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-form-input
                                label="CID 10"
                                v-model="examesSolicitados.cidDescricao"
                                disabled
                            />
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-form-input
                                label="CIAP 2"
                                v-model="examesSolicitados.ciapDescricao"
                                disabled
                            />
                        </rkm-col>


                        <rkm-col cols="12">
                            <rkm-form-textarea
                                label="Justificativa do procedimento"
                                rows="4"
                                v-model="examesSolicitados.justificativa"
                                disabled
                            />
                        </rkm-col>

                        <rkm-col cols="12">
                            <rkm-form-textarea
                                label="Observações"
                                rows="4"
                                v-model="examesSolicitados.observacao"
                                disabled
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col
                v-for="(exameSolicitado, index) in exameAvaliado"
                :key="index"
                class="mb-2"
                cols="6"
            >
                <rkm-list-group>
                    <rkm-list-group-item class="rkm-list-group-item">
                        <rkm-row>
                            <rkm-col
                                class="align-self-center"
                                cols="12"
                            >
                                <rkm-form-checkbox
                                    :checked="!!data.model.exameSolicitado.find(e => e.id === exameSolicitado.id)"
                                    @change.native="handleExameSolicitadoChange($event, exameSolicitado.id)"
                                >
                                    {{exameSolicitado.descricao}}
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-list-group-item>
                </rkm-list-group>
            </rkm-col>
        </rkm-row>

        <rkm-row class="p-2">

            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    :repository="repositories.cid"
                    :request-query-string-params="{sexo: data.additionals.paciente.sexoIdentificador}"
                    :search-fields="fields.autocomplete.cid"
                    :text-field="(item) => `${item.codigo} - ${item.nome}`"
                    :results-limit= "20"
                    label="CID 10"
                    v-model="data.model.exameSolicitadoCid"
                />
            </rkm-col>

            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    :repository="repositories.geral.ciap"
                    :request-query-string-params="{sexo_id: data.additionals.paciente.sexoId}"
                    :search-fields="fields.autocomplete.ciap"
                    :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                    label="CIAP 2"
                    v-model="data.model.exameSolicitadoCiap"
                />
            </rkm-col>

            <rkm-col cols="12">
                <rkm-form-textarea
                    :validations="validations.justificativa"
                    label="Justificativa do procedimento"
                    rows="4"
                    v-model="data.model.exameSolicitadoJustificativa"
                />
            </rkm-col>

            <rkm-col cols="12">
                <rkm-form-textarea
                    :validations="validations.observacao"
                    label="Observações"
                    rows="4"
                    v-model="data.model.exameSolicitadoObservacao"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'
import exameSolicitadoAvaliado from '@/enums/atencao-basica/atendimento-individual/exameSolicitadoAvaliado'

export default {
    computed: {
        validations() {
            return {
                exame: {required: true},
                justificativa: {
                    required: this.data.model.exameSolicitado.length > 0 ? true : false,
                    max: 500,
                },
                observacao: {max: 500},
            }
        },
        exameAvaliado() {
            return this.data.additionals.paciente.sexoId == this.enums.sexo.FEMININO
                && this.data.additionals.paciente.idadeAnos > 9 && this.data.additionals.paciente.idadeAnos < 60
                ? this.data.form.exameSolicitadoAvaliado
                : this.data.form.exameSolicitadoAvaliado.filter(exame => exame.id != this.enums.exameSolicitadoAvaliado.TESTE_DE_GRAVIDEZ)
        }
    },
    created() {
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid'),
            geral: this.getConectaSusRepository('geral'),
        }
    },
    data: () => ({
        fields: {
            autocomplete: {
                cid: [
                    {key: 'codigo', searchable: true},
                    {key: 'nome', searchable: true},
                ],
                ciap: [
                    {key: 'geral_ciap.codigo', searchable: true},
                    {key: 'geral_ciap.descricao', searchable: true},
                ],
            },
        },
        enums: {sexo, exameSolicitadoAvaliado},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleExameSolicitadoChange(event, id) {

            if (event.target.checked) {
                this.data.model.exameSolicitado.push({
                    id: parseInt(id),
                })
            } else {
                this.data.model.exameSolicitado.splice(this.data.model.exameSolicitado.findIndex(exame => exame.id === parseInt(id)) , 1)
            }
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        data: {type: Object, required: true},
    },
}
</script>

<style scoped>
.rkm-list-group-item {
    padding: 0.2rem 0.2rem;
}
.rkm-list-group-item:focus {
    outline: none;
}
.rkm-list-group-item:first-child {
    border-radius: 0;
}
.rkm-list-group-item:last-child {
    border-radius: 0;
}
.rkm-list-group-item > .row {
    margin: 0;
}
.rkm-collapse {
    border-bottom: 1px solid rgba(0, 0, 0, .15);
    border-left: 1px solid rgba(0, 0, 0, .15);
    border-right: 1px solid rgba(0, 0, 0, .15);
}
</style>